import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
    FacebookShareButton,
    LinkedinShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton,
  } from "react-share";
import './ShareSocial.css';

const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL || 'http://localhost:3000';

const ShareSocial = ({shareDetail}) => {
    const [copied, setCopied] = useState(false);
    const shareUrl = `${DOMAIN_URL}/detail/${shareDetail.nft_id || shareDetail.id}`;

    const copyToClipboard = () => {
        navigator.clipboard.writeText(shareUrl).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }).catch(err => {
            console.error('Failed to copy:', err);
        });
    };

    return (
        <div className="modal fade" id="ShareModal" tabIndex="-1" aria-labelledby="ShareModalLabel"
                aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered share-modal-custom">
                <div className="modal-content share-modal-content">
                    <div className="modal-header share-modal-header">
                        <div className="share-modal-title-wrapper">
                            <i className="fas fa-share-alt share-modal-icon"></i>
                            <h5 className="modal-title share-modal-title" id="ShareModalLabel">
                                Share "{shareDetail.title || 'this NFT'}"
                            </h5>
                        </div>
                        <button type="button" className="btn-close share-modal-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                    </div>
                    <div className="modal-body share-modal-body">
                        {/* Copy Link Section */}
                        <div className="share-copy-link-section">
                            <label className="share-label">Share Link</label>
                            <div className="share-copy-link-container">
                                <input 
                                    type="text" 
                                    value={shareUrl} 
                                    readOnly 
                                    className="share-link-input"
                                />
                                <button 
                                    onClick={copyToClipboard} 
                                    className={`share-copy-btn ${copied ? 'copied' : ''}`}
                                >
                                    {copied ? (
                                        <>
                                            <i className="fas fa-check"></i> Copied!
                                        </>
                                    ) : (
                                        <>
                                            <i className="far fa-copy"></i> Copy
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>

                        {/* Social Share Buttons */}
                        <div className="share-social-section">
                            <label className="share-label">Share on Social Media</label>
                            <div className="share-social-buttons">
                                <FacebookShareButton 
                                    title={shareDetail.title} 
                                    quote={shareDetail.description} 
                                    hashtag="#nftcity #nft" 
                                    url={shareUrl}
                                    className="share-social-btn facebook-btn"
                                > 
                                    <div className="share-btn-content">
                                        <i className="fab fa-facebook-f"></i>
                                        <span>Facebook</span>
                                    </div>
                                </FacebookShareButton>

                                <TwitterShareButton  
                                    title={shareDetail.title} 
                                    hashtags={["nftcity", "nft"]} 
                                    url={shareUrl}
                                    className="share-social-btn twitter-btn"
                                > 
                                    <div className="share-btn-content">
                                        <i className="fab fa-twitter"></i>
                                        <span>Twitter</span>
                                    </div>
                                </TwitterShareButton>

                                <LinkedinShareButton  
                                    title={shareDetail.title} 
                                    summary={shareDetail.description} 
                                    url={shareUrl}
                                    className="share-social-btn linkedin-btn"
                                > 
                                    <div className="share-btn-content">
                                        <i className="fab fa-linkedin-in"></i>
                                        <span>LinkedIn</span>
                                    </div>
                                </LinkedinShareButton>

                                <TelegramShareButton  
                                    title={shareDetail.title} 
                                    url={shareUrl}
                                    className="share-social-btn telegram-btn"
                                > 
                                    <div className="share-btn-content">
                                        <i className="fab fa-telegram-plane"></i>
                                        <span>Telegram</span>
                                    </div>
                                </TelegramShareButton>

                                <WhatsappShareButton  
                                    title={shareDetail.title} 
                                    url={shareUrl}
                                    className="share-social-btn whatsapp-btn"
                                > 
                                    <div className="share-btn-content">
                                        <i className="fab fa-whatsapp"></i>
                                        <span>WhatsApp</span>
                                    </div>
                                </WhatsappShareButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    shareDetail: state.ShareSocial.shareSocial
})

export default connect(mapStateToProps, {})(ShareSocial);